import React, { FC, useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";

import { LoadingSpinner } from "@mapmycustomers/ui";

import { RootState } from "@app/store/rootReducer";

import AddResourcesWizard from "./components/AddResourcesWizard";
import AddLinkStep from "./components/AddResourcesWizard/AddLinkStep";
import ShareResourcesStep from "./components/AddResourcesWizard/ShareResourcesStep";
import UploadFilesStep from "./components/AddResourcesWizard/UploadFilesStep";
import Header from "./components/Header";
import PinnedResources from "./components/PinnedResources";
import ResourceList from "./components/ResourceList";
import Sidebar from "./components/Sidebar";
import ResourceType from "./enum/ResourceType";
import styles from "./Resources.module.scss";
import { isInitializing } from "./store";
import { initialize } from "./store/actions";

const addFileResourcesSteps = [UploadFilesStep, ShareResourcesStep];
const addLinkResourceSteps = [AddLinkStep, ShareResourcesStep];

export interface RescourcePageProps {
  initializing: boolean;
  onInitialize: typeof initialize.request;
}

const RescourcePage: FC<RescourcePageProps> = ({ initializing, onInitialize }) => {
  const [addResouceType, setAddResourceType] = useState<ResourceType>();

  const steps =
    addResouceType === ResourceType.FILE
      ? addFileResourcesSteps
      : addResouceType === ResourceType.LINK
      ? addLinkResourceSteps
      : undefined;

  const handleHideAddWizard = useCallback(() => setAddResourceType(undefined), []);

  useEffect(() => {
    onInitialize();
  }, [onInitialize]);

  return initializing ? (
    <LoadingSpinner global />
  ) : (
    <div className={styles.container}>
      <Header onAddResourceClick={setAddResourceType} />
      <div className={styles.content}>
        <PinnedResources />
        <div className={styles.resources}>
          <Sidebar />
          <ResourceList onChangeResourceType={setAddResourceType} />
        </div>
      </div>
      {steps && <AddResourcesWizard onHide={handleHideAddWizard} steps={steps} />}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  initializing: isInitializing(state),
});

const mapDispatchToProps = {
  onInitialize: initialize.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(RescourcePage);
